module.exports = "<div [formGroup]=\"buttonOptions\">\n    <div class=\"btn-group btn-group-sm\" data-toggle=\"buttons\" formArrayName=\"options\">\n        <label ngbButtonLabel class=\"btn btn-sm btn-outline-primary\" *ngFor=\"let option of options; let i = index\">\n            <input type=\"checkbox\" [formControlName]=\"i\" ngbButton />\n            {{option.label}}\n        </label>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/button-options.component.html
// module id = 627
// module chunks = 1